/**
 * Serialize an object for embedding inside a <script type="application/ld+json">
 * tag WITHOUT allowing an HTML-parser breakout.
 *
 * JSON.stringify does not escape "<", ">" or "&", so a value containing
 * "</script>" would terminate the script element and let injected markup run
 * (stored XSS via user-controlled listing titles / descriptions / agent names).
 * Escaping those three to their \uXXXX forms keeps the output VALID JSON —
 * structured-data consumers still parse it — but the literal "</script>" can
 * never appear in the raw HTML. (U+2028/U+2029 need no handling here: this is
 * ld+json data, not executed JavaScript, so they are harmless JSON whitespace.)
 */
export function jsonLdScript(obj: unknown): string {
  return JSON.stringify(obj)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
}
